var itr = itr || {};
( function () {
    'use strict';

    jQuery(window).on('load', function() {
        e4.deferImages.init();
    });
    
    jQuery( function () {
        itr.redirects.init();
        itr.navigationSetTarget.init();
        itr.forms.init();
        itr.support.init();
        itr.gdpr.init();
        itr.joboffers.init();
        itr.checkbox.init();
        itr.backToFront .init();
        itr.activeCampaign.init();
        itr.leasingProductCalc.init();
        itr.verticalLocalNavWidth.init();
        itr.redirectModel.init();
    } );

    itr.utils = {
        formatStringToJavascriptNumber: function ( strNumber ) {
            return parseFloat( String( strNumber ).replace( new RegExp( '\\' + e4.settings.separatorInteger, 'g' ), '' ).replace( new RegExp( '\\' + e4.settings.separatorDecimal, 'g' ), '.' ) );
        },
        formatJavascriptNumberToLocaleString: function ( intNumber ) {
            var strNumber = String( parseFloat( Math.round( intNumber * 100 ) / 100 ).toFixed( 2 ) ).replace( /[^\d\.\-]/g, '' ).replace( /(\.\d{2})[\W\w]+/g, '$1' ).split( '' ).reverse().join( '' ).replace( /(\d{3})/g, '$1.' ).split( '' ).reverse().join( '' ).replace( /^([\-]{0,1})\./, '$1' ).replace( /\.(\d\d)$/, ',' + '$1' ).replace( /\.(\d)$/, ',' + '$1' + '0' ).replace( /\.$/, ',00' );
            if ( e4.settings.lang !== 'da' ) {
                strNumber = strNumber.replace( /\./g, '{integer}' );
                strNumber = strNumber.replace( /\,/g, '{decimal}' );
                strNumber = strNumber.replace( /{integer}/g, e4.settings.separatorInteger );
                strNumber = strNumber.replace( /{decimal}/g, e4.settings.separatorDecimal );
            }
            return strNumber;
        }
    };
    itr.leasingProductCalc = {
        init: function () {
            itr.leasingProductCalc.monthlyPayments();
        },
        monthlyPayments: function () {

            jQuery( '.leasing-price-total' ).on( 'input', function ( event ) {
                var parentRow = jQuery( event.target ).closest('.js-leasing-product'),
                    leasingPriceTotal = jQuery( event.target ).val(),
                    leasingFactor = parentRow.find( '.leasing-factor' ).val(),
                    leasingDuration = parentRow.find( '.leasing-duration' ).val(),
                    leasingMonthlyPayments = parentRow.find( '.leasing-monthly-payments' ),
                    leasingMonthlyPaymentsContainerVisible = parentRow.find('.leasing-monthly-payments-container'),
                    calculatedValue = (parseInt( leasingPriceTotal ) * parseFloat( leasingFactor )) / 100;

                //console.log('ALLE værdier: ', leasingPriceTotal, leasingFactor, leasingDuration);
                //console.log('UDREGNET Værdi: ', calculatedValue);

                leasingMonthlyPayments.html(itr.utils.formatJavascriptNumberToLocaleString(calculatedValue));
                leasingMonthlyPayments.data('leasing-monthly-payments', calculatedValue);

                if (leasingPriceTotal !== '')
                {
                    leasingMonthlyPaymentsContainerVisible.removeClass('invisible');
                } else {
                    leasingMonthlyPayments.val(0);
                    leasingMonthlyPaymentsContainerVisible.addClass('invisible');
                }

                itr.leasingProductCalc.calcToggle();

            } );
        },
        calcToggle: function () {
            var total = 0;
            jQuery( '.leasing-monthly-payments' ).each(function( index, elm ) {
                var leasingMonthlyPayments = jQuery(elm).data('leasing-monthly-payments');
                total += leasingMonthlyPayments;
            });
            jQuery( '.leasing-total-price' ).html(itr.utils.formatJavascriptNumberToLocaleString(total));
        }
    };
    itr.gdpr = {
        lang: jQuery( 'html' ).attr( 'lang' ),
        init: function () {
            itr.gdpr.add();
        },
        add: function () {
            jQuery( 'form' ).find( 'label, .form-group, ._error-inner' ).each( function () {
                var html = jQuery( this ).html();
                if ( html.indexOf( '{gdpr1}' ) > -1 ) {
                    html = html.replace( '{gdpr1}', '<a href="' + window.gdprData[ itr.gdpr.lang ].gdpr1.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr1.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr2}' ) > -1 ) {
                    html = html.replace( '{gdpr2}', '<a href="' + window.gdprData[ itr.gdpr.lang ].gdpr2.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr2.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr3}' ) > -1 ) {
                    html = html.replace( '{gdpr3}', '<a href="' + window.gdprData[ itr.gdpr.lang ].gdpr3.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr3.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr4}' ) > -1 ) {
                    html = html.replace( '{gdpr4}', '<a href="' + window.gdprData[ itr.gdpr.lang ].gdpr4.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr4.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr5}' ) > -1 ) {
                    html = html.replace( '{gdpr5}', '<a href="' + window.gdprData[ itr.gdpr.lang ].gdpr5.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr5.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr6}' ) > -1 ) {
                    html = html.replace( '{gdpr6}', '<a href="' + window.gdprData[ itr.gdpr.lang ].gdpr6.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr6.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr7}' ) > -1 ) {
                    html = html.replace( '{gdpr7}', window.gdprData[ itr.gdpr.lang ].gdpr7.text1 + ' <a href="' + window.gdprData[ itr.gdpr.lang ].gdpr7.url + '" target="_blank">' + window.gdprData[ itr.gdpr.lang ].gdpr7.linktext + '</a>. ' + window.gdprData[ itr.gdpr.lang ].gdpr7.text2 );
                    jQuery( this ).html( html );
                }
            } );
        }
    };
    itr.redirects           = {
        init: function () {
            if ( location.hash === '#softcom' || location.hash === '#ita' || location.hash === '#dsi' || location.hash === '#frontdata' || location.hash === '#wwi' || location.hash === '#aci' || location.hash === '#techbiz' ) {
                jQuery( '.js-itr-redirect-' + location.hash.substring( 1 ) ).removeClass( 'd-none' );
                jQuery( '#js-itr-redirect-modal' ).on( 'show.bs.modal', function () {
                    location.hash = '';
                } ).modal( 'show' );
            }
        }
    };
    itr.navigationSetTarget = {
        init: function () {
            jQuery( '.e-nav-global .nav-link[href^="http"]' ).attr( 'target', '_blank' );
        }
    };
    itr.forms               = {
        init: function () {
            itr.forms.sendingSpinner();
        },
        sendingSpinner: function () {
            jQuery( '.js-e-form-dw' ).on( 'submit', function () {
                //console.log( 'click' );
                if ( jQuery( this ).valid() === true ) {
                    jQuery( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).addClass( 'loading' );
                }
                else {
                    jQuery( this ).find( 'button[type="submit"]' ).prop( 'disabled', false ).removeClass( 'loading' );
                }
            } );
        },
        webinarjam: {
            fallbackWebicode: 'a3b41e8fb1', //Inspiration til Microsoft Teams
            registrationUrl: 'https://events.genndi.com/auto-register?webicode={0}&memberid=818182175026330192&firstname={1}&lastname={2}&email={3}&schedule=1',
            init: function () {
                jQuery( '.js-itr-form-webinarjam-registration' ).each( function ( intIndex, domForm ) {
                    jQuery( domForm ).data( 'validator' ).settings.submitHandler = itr.forms.webinarjam.submitHandler;
                } );
            },
            submitHandler: function ( domForm ) {
                var jForm = jQuery( domForm );
                if ( jForm.is( '.js-e-form-dw' ) === true ) {
                    //Read Dynamicweb spam script from inline script block inside the forms.
                    e4.data.forms.dwSpamScripts[ domForm.id ]( domForm );
                    // console.log( e4.data.forms.dwSpamScripts );
                }
                jQuery.ajax( {
                    url: jForm.attr( 'action' ),
                    data: jForm.serialize(),
                    method: jForm.attr( 'method' ),
                    timeout: 3000,
                    dataType: 'html'
                } ).done( function ( data, textStatus, jqXHR ) {
                    var strNameFirst       = jForm.find( '.js-itr-form-webinarjam-registration-name-first' ).val(),
                        strNameLast        = jForm.find( '.js-itr-form-webinarjam-registration-name-last' ).val(),
                        strEmail           = jForm.find( '.js-itr-form-webinarjam-registration-email' ).val(),
                        strWebicode        = jForm.find('.js-itr-form-webinarjam-registration-webicode').length > 0 ? jForm.find('.js-itr-form-webinarjam-registration-webicode').val() : itr.forms.webinarjam.fallbackWebicode,
                        strRegistrationUrl = jQuery.validator.format( itr.forms.webinarjam.registrationUrl, strWebicode, strNameFirst, strNameLast, strEmail );
                    location.href = strRegistrationUrl;
                } );
            }
        }
    };
    itr.joboffers           = {
        globals: {
            apiUrl: '//hr-skyen.dk/hr/api/jobs/',
            key: 'itrelation',
            locale: 'da_DK'
        },
        init: function () {
            if ( jQuery( '.js-itr-joboffers-container' ).length > 0 ) {
                itr.joboffers.bindEvents();
                jQuery.getScript( 'Files/Templates/Designs/itr/_assets/js/vendor/handlebars.min.js', function () {
                    itr.joboffers.handlebars.registerTemplates();
                    if ( location.hash.length ) {
                        var jobID = location.hash.replace( '#', '' );
                        itr.joboffers.data.get( itr.joboffers.globals.apiUrl + itr.joboffers.globals.key + '/' + jobID, 'details' );
                    }
                    else {
                        itr.joboffers.data.get( itr.joboffers.globals.apiUrl + itr.joboffers.globals.key, 'list' );
                    }
                } );
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'popstate', function () {
                itr.joboffers.data.get( itr.joboffers.globals.apiUrl + itr.joboffers.globals.key, 'list' );
            } );
            jQuery( '.js-itr-joboffers-container' ).on( 'click', '.js-itr-joboffers-details-link', function ( event ) {
                event.preventDefault();
                var jobID    = jQuery( this ).attr( 'href' ).replace( '#', '' ),
                    jobTitle = jQuery( this ).attr( 'title' );
                itr.joboffers.data.get( itr.joboffers.globals.apiUrl + itr.joboffers.globals.key + '/' + jobID, 'details' );
                history.pushState( null, jobTitle, location.href.replace( '/stilling#', '' ) + '/stilling#' + jobID );
            } ).on( 'click', '.js-itr-joboffers-toggler', function ( event ) {
                event.preventDefault();
                jQuery( '.js-itr-joboffers-toggle-target' ).slideToggle( 'fast' );
            } ).on( 'click', '.js-itr-joboffers-text-toggle', function ( event ) {
                event.preventDefault();
                jQuery( '.js-itr-joboffers-toggle-text' ).slideToggle( 'fast' );
            } );
        },
        handlebars: {
            tmpl: {
                list: null,
                details: null
            },
            registerTemplates: function () {
                itr.joboffers.handlebars.tmpl.list    = Handlebars.compile( jQuery( '#js-e-handlebars-tmpl-joboffers-list' ).html() );
                itr.joboffers.handlebars.tmpl.details = Handlebars.compile( jQuery( '#js-e-handlebars-tmpl-joboffers-details' ).html() );
            },
            build: function ( data, type ) {
                jQuery( '.js-itr-joboffers-container' ).html( itr.joboffers.handlebars.tmpl[ type ]( data ) );
            }
        },
        data: {
            get: function ( url, type ) {
                jQuery( '.itr-job-loading-overlay' ).addClass( 'is-loading' );
                jQuery.getJSON( url, {
                    locale: itr.joboffers.globals.locale
                }, function ( json ) {
                    itr.joboffers.handlebars.build( json, type );
                    jQuery( '.itr-job-loading-overlay' ).removeClass( 'is-loading' );
                } );
            }
        }
    };
    itr.support             = {
        init: function () {
            itr.support.bindEvents();
            if ( localStorage.supportItem !== undefined ) {
                jQuery( '.js-support-section[data-support-id="Default"]' ).hide();
                jQuery( '.js-support-section[data-support-id="' + localStorage.supportItem + '"]' ).show();
                jQuery( '.js-support-section-check[value="' + localStorage.supportItem + '"]' ).prop( 'checked', true );
            }
            else {
                jQuery( '.js-support-section[data-support-id="Default"]' ).show();
            }
            jQuery( '.js-support-section-select' ).each( function () {
                var stdValue = jQuery( this ).val();
                jQuery( this ).attr( 'data-standard-value', stdValue );
            } );
        },
        bindEvents: function () {
            jQuery( '.js-support-section-select' ).on( 'change', function () {
                var sectionID = jQuery( this ).val();
                jQuery( '.js-support-section' ).hide();
                jQuery( '.js-support-section[data-support-id="' + sectionID + '"]' ).fadeIn( 'fast' );
                jQuery( this ).val( jQuery( this ).data( 'standard-value' ) );
            } );
            jQuery( '.js-support-section-check' ).on( 'click', function () {
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    var sectionID = jQuery( this ).val();
                    jQuery( '.js-support-section-check[value!="' + sectionID + '"]' ).prop( 'checked', false );
                    localStorage.supportItem = sectionID;
                }
                else {
                    localStorage.removeItem( 'supportItem' );
                }
            } );
            jQuery( '.js-support-help' ).on( 'click', function ( event ) {
                event.preventDefault();
                jQuery( '#js-support-modal' ).modal();
            } );
        }
    };
    itr.checkbox            = {
        init: function () {
            jQuery( 'form' ).find( 'input[type=checkbox]' ).prop( 'checked', false );
        }
    };
    itr.backToFront            = {
        init: function () {
            jQuery( "<a href='/' class='arrow-left text-auto text-muted'>Tilbage til forsiden</a>" ).insertAfter( $( ".addthis_inline_share_toolbox" ) );
        }
    };
    itr.activeCampaign      = {
        init: function () {
            if ( jQuery( '.js-itr-activecampaign' ).length > 0 ) {
                itr.activeCampaign.customCheckbox();
                itr.activeCampaign.requiredStar();
                itr.activeCampaign.styling();
                itr.activeCampaign.errorMsg.init();
                itr.activeCampaign.currentUrl();
            }

        },
        customCheckbox: function () {
            var jActiveCampaignObj = jQuery('.js-itr-activecampaign');
            jActiveCampaignObj.find('._checkbox-radio').addClass('custom-checkbox');
            jActiveCampaignObj.find('._checkbox-radio > input').addClass('custom-control-input').after('<span class="custom-control-indicator"></span>');
        },
        currentUrl: function ()
        {
            if ( jQuery('.js-itr-activecampaign').find('input[data-name=getcurrenturldk]')) {
                jQuery('._form_element').has('input[data-name="getcurrenturldk"]').addClass('d-none');
                var getCurrentUrl = window.location.href;
                jQuery('.js-itr-activecampaign').find( 'input[data-name=getcurrenturldk]' ).val( getCurrentUrl );
                //console.log('NY URL: ', getCurrentUrl)
            }
            if ( jQuery('.js-itr-activecampaign').find('input[data-name=getcurrenturluk]')) {
                jQuery('._form_element').has('input[data-name="getcurrenturluk"]').addClass('d-none');
                var getCurrentUrl = window.location.href;
                jQuery('.js-itr-activecampaign').find( 'input[data-name=getcurrenturluk]' ).val( getCurrentUrl );
                //console.log('NY URL: ', getCurrentUrl)
            }
        },
        requiredStar: function () {
            var jActiveCampaignObj = jQuery('.js-itr-activecampaign');
            jActiveCampaignObj.find('label').each(function (  ) {
                var jLabelHtml = jQuery(this).html();
                jQuery(this).html(jLabelHtml.replace('*', ' <span class="text-danger">*</span>'));
            });
        },
        styling: function () {
            var jFooterForm = jQuery('.e-footer').find('.js-itr-activecampaign');
            jFooterForm.find('label').css({
                'color': '#d9d9d9'
            });
            jQuery('.js-itr-activecampaign').find('._button-wrapper ._submit').removeClass('_submit').addClass('btn btn-primary');
        },
        errorMsg: {
            removeClasses: function() {
                jQuery( '.custom-control-input' ).removeClass( 'custom-control-input' );
                jQuery( '.custom-control-indicator' ).removeClass( 'custom-control-indicator' );
            },
            onSubmit: function() {
                jQuery('._form').on('submit', function(){
                    itr.gdpr.init();
                    if ( !jQuery( this ).find( 'input[type=checkbox]' ).is( ':checked' ) ) {
                        itr.activeCampaign.errorMsg.removeClasses();
                    }
                });
            },
            onChange: function() {
                jQuery('._form').on('change', 'input[type=checkbox]', function(){
                    itr.gdpr.init();
                    if ( jQuery( this ).is( ':checked' ) ) {
                        itr.activeCampaign.customCheckbox();
                    } else {
                        itr.activeCampaign.errorMsg.removeClasses();
                    }
                });
            },
            init: function() {
                itr.activeCampaign.errorMsg.onSubmit();
                itr.activeCampaign.errorMsg.onChange();
            }
        }
    };

    itr.verticalLocalNavWidth = {
        adjustWidth: function () {
            var itrLocalVerticalNav = jQuery( '.js-e-nav-local-vertical' );
            if( itrLocalVerticalNav.length > 0 && itrLocalVerticalNav.hasClass( 'is-sticky' ) ) {
                itrLocalVerticalNav.width( jQuery( '#dwcontentmain' ).width() - 30 );
                //console.log( 'Adjusted width' );
            }
        },
        bindEvents: function () {
                jQuery( window ).on( 'resize', function () {
                    itr.verticalLocalNavWidth.adjustWidth();
                    //console.log( 'Resizing' );
                } );
        },
        init: function () {
            itr.verticalLocalNavWidth.adjustWidth();
            itr.verticalLocalNavWidth.bindEvents();
        }
    };
    
    itr.redirectModel = {
        init: function () {
            if( window.location.href.indexOf( "?itadel=true" ) !== -1 ){
                $(window).on('load', function() {
                    $('#redirectModel').modal('show');
                });
            }
        }
    };
    
    // News V2 image popup
    jQuery('.pop').on('click', function(e) {
        e.preventDefault();
        jQuery('.imagepreview').attr('src', jQuery(this).find('img').attr('data-src'));
        jQuery('#imagemodal').modal('show');
    });
} )();

